import * as React from 'react';
import { reduxForm } from 'redux-form';
import { Trans, withTranslation } from 'react-i18next';

import FileCropInput from '@common/components/form/inputs/file-crop';
import {
  Row, Group, Label, TextInput, SelectInput,
} from '@common/components/form';
import ColorInput from '@common/components/form/inputs/color';
import { Button } from '@common/components/button';
import ThemePreview from '@common/components/theme-preview';
import Icon from '@common/components/icon';

import { setupTrial } from '../../actions';
import { selectOrganisation } from '../../../organisation/actions';

const companySizeOptions = [{
  value: '< 50',
  label: '< 50',
}, {
  value: '51 - 200',
  label: '51 - 200',
}, {
  value: '201 - 500',
  label: '201 - 500',
}, {
  value: '501 - 1000',
  label: '501 - 1000',
}, {
  value: '1001 - 2500',
  label: '1001 - 2500',
}, {
  value: '2501 - 5000',
  label: '2501 - 5000',
}, {
  value: '5001 - 10.000',
  label: '5001 - 10.000',
}, {
  value: '10.001 >',
  label: '10.001 >',
}];

const industries = {
  RETAIL: 'Retail',
  HOSPITALITY: 'Hospitality',
  TRAVEL_TOURISM: 'Travel & Tourism',
  QUICK_SERVICE_RESTAURANTS: 'QSR',
  SUPERMARKETS: 'Supermarkets',
  MANUFACTURING: 'Manufacturing',
  FOOD_PRODUCTION: 'Food Production',
  HEALTHCARE: 'Healthcare',
  LOGISTICS: 'Logistics',
  FACILITY_SERVICES: 'Facility Services',
  CONSTRUCTION: 'Construction',
  OTHER: 'Other',
};

class OnboardingForm extends React.Component {
  static defaultProps = {
    formValues: {},
  };

  constructor() {
    super();

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  static props;

  async handleSubmit(values, dispatch) {
    const { organisationId } = this.props;

    await dispatch(setupTrial(organisationId, values));

    const path = await dispatch(selectOrganisation(organisationId));

    this.props.history.push(path);
  }

  render() {
    const {
      loggedUser, formValues, onBack, change, handleSubmit, submitting, invalid, t,
    } = this.props;

    const filePreview = formValues.brand_icon && URL.createObjectURL(formValues.brand_icon);

    const industryOptions = Object.keys(industries).map((industry) => ({
      value: industries[industry],
      label: t(`authentication:company_industry_${industry.toLowerCase()}`),
    }));

    return (
      <>
        <form className="Form Onboarding__Form" onSubmit={handleSubmit(this.handleSubmit)}>
          <h1><Trans i18nKey="authentication:tell_about_company" /></h1>
          <h5><Trans i18nKey="authentication:company_information" /></h5>
          <Row>
            <Group>
              <FileCropInput onSubmit={(file) => change('brand_icon', file)}>
                <div className="OrganisationLogoInput">
                  {filePreview ? <img alt="Brand icon" src={filePreview} /> : <Icon type="radio_button_unchecked" />}
                  <Button type="inverted"><Trans i18nKey="authentication:onboarding_upload_logo" /></Button>
                </div>
              </FileCropInput>
            </Group>
          </Row>
          <Row>
            <Group>
              <TextInput name="name" placeholder={t('authentication:onboarding_company_name')} />
            </Group>
          </Row>
          <Row>
            <Group>
              <SelectInput
                name="company_size"
                options={companySizeOptions}
                placeholder={t('authentication:onboarding_company_size')}
              />
            </Group>
            <Group>
              <SelectInput
                name="industry"
                options={industryOptions}
                placeholder={t('authentication:onboarding_company_industry')}
              />
            </Group>
          </Row>
          <hr />
          <h5><Trans i18nKey="authentication:company_branding" /></h5>
          <Row>
            <Group>
              <Label text={t('organisation:forms_theme_main_color')} />
              <ColorInput name="theme.main_color" defaultColor="#19214D" />
            </Group>
            <Group>
              <Label text={t('organisation:forms_theme_button_color')} />
              <ColorInput name="theme.button_color" defaultColor="#007AFF" />
            </Group>
          </Row>
          <Button
            type="primary"
            size="fill"
            buttonType="submit"
            isLoading={submitting}
            disabled={invalid}
          >
            <Trans i18nKey="authentication:onboarding_start_trial" />
          </Button>
          {onBack && <Button size="fill" onClick={onBack}><Trans i18nKey="authentication:onboarding_back" /></Button>}
        </form>
        <div className="Onboarding__Preview">
          {formValues && formValues.theme && (
            <style>
              {`*[fill="primaryColor"] {
                fill: ${formValues.theme.main_color};
              }

              *[fill="buttonColor"] {
                fill: ${formValues.theme.button_color};
              }`}
            </style>
          )}
          <ThemePreview
            loggedUser={loggedUser}
            organisation={{ name: formValues.name, brand_icon: filePreview, theme: {} }}
          />
        </div>
      </>
    );
  }
}

export default withTranslation()(reduxForm({
  form: 'onboarding',
  initialValues: {
    brand_icon: null,
    name: '',
    theme: {
      main_color: '#19214D',
      button_color: '#19214D',
    },
  },
  validate: require('./validate').default,
})(OnboardingForm));
